import { useQuery } from '@tanstack/react-query';
import { configApi } from '../../configApi';

interface IResultState {
  id: string;
  name: string;
}

const RequestGetGender = async () => {
  const response = await configApi.get<IResultState[]>('general-records/gender-identity/');
  return response.data;
};

export const useRequestGetGenderIdentity = () => {
  return useQuery({
    queryKey: ['get_gender_identity'],
    queryFn: RequestGetGender,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });
};
